import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({ breakpoints, palette, tokens, px })=>({
        multipleAutocompleteInput: {
            width: '100%'
        },
        defaultMargin: {
            marginBottom: tokens.spacing['16']
        },
        input: {
            '& .MuiInputBase-root': {
                paddingRight: 0,
                lineHeight: 1.5,
                backgroundColor: tokens.colors.bg.light.primary,
                '&.MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
                    padding: 0
                },
                '&.MuiOutlinedInput-root.MuiAutocomplete-inputRoot .MuiInputBase-input': {
                    minWidth: 0,
                    paddingRight: 0,
                    paddingLeft: tokens.spacing['12'] + px(2),
                    paddingTop: tokens.spacing['16'] + px(2.5),
                    paddingBottom: tokens.spacing['16'] + px(2.5)
                },
                '& .MuiSelect-iconOutlined': {
                    right: tokens.spacing['16']
                },
                '&.Mui-focused': {
                    '& .multipleAutocompleteClearIcon': {
                        display: 'block'
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: tokens.colors.original.brand.primary,
                        borderWidth: tokens.border.s
                    }
                },
                '&.Mui-error': {
                    backgroundColor: tokens.colors.accent.bg.error,
                    '& fieldset': {
                        borderColor: tokens.colors.accent.stroke.error
                    },
                    '&.Mui-focused': {
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: tokens.colors.accent.text.error
                        }
                    },
                    '&:hover': {
                        '& fieldset': {
                            borderColor: palette.error.hover
                        }
                    }
                },
                '&.Mui-disabled': {
                    backgroundColor: tokens.colors.bg.greyscale.secondary,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: tokens.colors.stroke.primary
                    }
                },
                '& fieldset': {
                    borderColor: tokens.colors.stroke.primary
                },
                '&:hover': {
                    '& .multipleAutocompleteClearIcon': {
                        display: 'block'
                    },
                    '& fieldset': {
                        borderColor: tokens.colors.stroke.secondary
                    }
                },
                '& .MuiIconButton-root:hover': {
                    backgroundColor: 'transparent'
                },
                '& .MuiAutocomplete-endAdornment': {
                    position: 'relative',
                    display: 'flex',
                    right: '0 !important',
                    top: `calc(50% - ${px(14)}px)`,
                    transform: 'none',
                    '& .MuiIconButton-root': {
                        padding: 0
                    },
                    '& .MuiAutocomplete-popupIndicator': {
                        marginLeft: -tokens.spacing['2'],
                        '& .MuiTouchRipple-root': {
                            display: 'none'
                        }
                    }
                },
                '& ul.MuiAutocomplete-listbox': {
                    padding: 0,
                    margin: `${tokens.spacing['8']}px 0`,
                    maxHeight: px(270),
                    overflow: 'auto'
                }
            },
            '& .MuiFormHelperText-root.Mui-error': {
                marginLeft: 0,
                marginRight: 0
            }
        },
        option: {
            fontSize: tokens.typography.variant.body3.fontSize,
            lineHeight: tokens.typography.variant.body3.lineHeight,
            paddingTop: tokens.spacing['4'] - px(1),
            paddingRight: tokens.spacing['16'],
            paddingBottom: tokens.spacing['4'] - px(1),
            paddingLeft: tokens.spacing['16'],
            minHeight: px(48),
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            [breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            '&.Mui-focused': {
                backgroundColor: tokens.colors.bg.greyscale.secondary,
                '& .MuiButtonBase-root.MuiCheckbox-root:not(.Mui-checked) svg path': {
                    fill: tokens.colors.stroke.secondary
                }
            }
        },
        listItem: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        defaultWordBreak: {
            overflowWrap: 'break-word'
        },
        listItemLabel: {
            pointerEvents: 'auto',
            wordBreak: 'break-all',
            maxWidth: `calc(100% - ${px(42)}px)`
        },
        popupIndicator: {
            padding: tokens.spacing['2'],
            marginRight: -tokens.spacing['2']
        },
        popupIndicatorOpen: {
            transform: 'rotate(180deg)'
        },
        paper: {
            maxHeight: px(276),
            marginRight: 0,
            marginLeft: 0,
            marginTop: tokens.spacing['4'],
            marginBottom: tokens.spacing['4'],
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            },
            '& [data-focus="true"]': {
                backgroundColor: `${palette.action.hover}`
            },
            '& [aria-disabled="true"]': {
                cursor: 'default',
                opacity: palette.action.disabledOpacity,
                pointerEvents: 'none'
            }
        },
        listbox: {
            maxHeight: px(276)
        },
        checkboxLabel: {
            color: tokens.colors.text.light.secondary,
            fontSize: `${tokens.typography.variant.body3.fontSize}px !important`
        },
        clearIcon: {
            display: 'none',
            width: px(24),
            height: px(24),
            cursor: 'pointer'
        }
    }));
const MultipleAutocompleteInput_styles = useStyles;
export default MultipleAutocompleteInput_styles;
